import React from 'react';

function ComplexComparePage() {
  return (
    <div style={{ padding: '24px' }}>
      <h2 style={{ margin: 0, fontSize: '22px', fontWeight: 800 }}>비교하기</h2>
      <p style={{ marginTop: '10px', color: '#64748b', fontSize: '14px' }}>
        준비 중인 페이지입니다.
      </p>
    </div>
  );
}

export default ComplexComparePage;
